function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2857 2.25H12.5714V0.28125C12.5714 0.126563 12.4429 0 12.2857 0H11.7143C11.5571 0 11.4286 0.126563 11.4286 0.28125V2.25H4.57143V0.28125C4.57143 0.126563 4.44286 0 4.28571 0H3.71429C3.55714 0 3.42857 0.126563 3.42857 0.28125V2.25H1.71429C0.767857 2.25 0 3.00586 0 3.9375V16.3125C0 17.2441 0.767857 18 1.71429 18H14.2857C15.2321 18 16 17.2441 16 16.3125V3.9375C16 3.00586 15.2321 2.25 14.2857 2.25ZM14.8571 16.3125C14.8571 16.6219 14.6 16.875 14.2857 16.875H1.71429C1.4 16.875 1.14286 16.6219 1.14286 16.3125V6.75H14.8571V16.3125ZM14.8571 5.625H1.14286V3.9375C1.14286 3.62812 1.4 3.375 1.71429 3.375H14.2857C14.6 3.375 14.8571 3.62812 14.8571 3.9375V5.625ZM4 13.5H7.42857C7.74286 13.5 8 13.2469 8 12.9375V9.5625C8 9.25313 7.74286 9 7.42857 9H4C3.68571 9 3.42857 9.25313 3.42857 9.5625V12.9375C3.42857 13.2469 3.68571 13.5 4 13.5ZM4.57143 10.125H6.85714V12.375H4.57143V10.125Z"
});

var SvgIcCalendarDay = function SvgIcCalendarDay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcCalendarDay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-calendar-day.f95838c3.svg";
export { ForwardRef as ReactComponent };